import {__NAME__, AppConfig} from './types'

export const config: AppConfig = window[__NAME__]
